var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"IP-role",style:({width: _vm.screenWidth + 'px', height: _vm.screenHeight + 'px'})},[_c('iframe',{ref:"iframeRef",staticClass:"iframe",attrs:{"name":"user-buy","src":_vm.embeddedLink}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-095b37ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emodal/IPRolePay/IPRolePayModal.vue
// module id = null
// module chunks = 